import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  ListGroup,
  ListGroupItem } from 'reactstrap';

class Method extends Component {
  render() {
    return (
      <div>
        <Card className="text-left dark-shadow mb-0 animated fadeInUp delay-200ms">
          <ListGroup>
            <ListGroupItem tag={Link} to="/dtc/2fa/text" href="/text-to-apply" className="d-flex">
              <div className="icon-bubble mr-2">
                <img src="/icons/2fa-sms.svg" alt="Text to Apply" style={{ position: "relative", left: "-1px" }} />
              </div>
              <div>
                <h5 className="mb-0">SMS Text Message</h5>
                <small>Text a verification code</small>
              </div>
              <Button color="primary" className="btn-icon ml-auto" tag="div"><img src="/icons/arrow-right.svg" alt="Select" /></Button>
            </ListGroupItem>
          </ListGroup>
        </Card>
        <div className="text-divider animated fadeInUp delay-600ms">
          <span className="line-left" style={{width: "45%"}}></span>
          <span className="text">OR</span>
          <span className="line-right" style={{width: "45%"}}></span>
        </div>
        <Card className="text-left dark-shadow animated fadeInUp delay-400ms">
          <ListGroup>
            <ListGroupItem tag={Link} to="/dtc/2fa/call" className="d-flex">
              <div className="icon-bubble mr-2">
                <img src="/icons/2fa-phone.svg" alt="Review" style={{ position: "relative", top: "-1px", right: "-1px" }} />
              </div>
              <div>
                <h5 className="mb-0">Phone Call</h5>
                <small>Receive phone call verification</small>
              </div>
              <Button color="primary" className="btn-icon ml-auto" tag="div"><img src="/icons/arrow-right.svg" alt="Select" /></Button>
            </ListGroupItem>
          </ListGroup>
        </Card>
      </div>
    )
  }
}

export default Method;
